import { render, staticRenderFns } from "./UnitBuilderListItem.vue?vue&type=template&id=0d85e49e&scoped=true&"
import script from "./UnitBuilderListItem.vue?vue&type=script&lang=js&"
export * from "./UnitBuilderListItem.vue?vue&type=script&lang=js&"
import style0 from "./UnitBuilderListItem.vue?vue&type=style&index=0&id=0d85e49e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85e49e",
  null
  
)

component.options.__file = "UnitBuilderListItem.vue"
export default component.exports